(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ShipmentDialogAgentController', ShipmentDialogAgentController);

    ShipmentDialogAgentController.$inject = ['$timeout','$scope','$stateParams','$q','$state','entity','Shipment','RequiredDocument','Comment','Contract',
        'ToastrService','ContractCustomService','Principal','$uibModal','CommentCustomService','AttachmentCustomService','KeywordCustomService',
        'ShipmentCustomService','$rootScope','MiscService','ShipmentDocumentCustomService','ShipmentDocument','RequiredDocumentCustomService','DateUtils'];

    function ShipmentDialogAgentController($timeout, $scope, $stateParams, $q, $state, entity, Shipment, RequiredDocument, Comment, Contract,
                                           ToastrService, ContractCustomService, Principal, $uibModal, CommentCustomService, AttachmentCustomService, KeywordCustomService,
                                           ShipmentCustomService, $rootScope, MiscService, ShipmentDocumentCustomService,
                                           ShipmentDocument, RequiredDocumentCustomService, DateUtils) {

        var vm = this;
        vm.shipment = entity;
        vm.comment = "";
        vm.comments = [];
        vm.attachments = [];
        vm.shipmentCompanyList = [];
        vm.shipmentCompany = vm.shipment.shipmentCompany;
        resolveComments();
        resolveAttachments();
        resolveShipmentDocument(vm.shipment.id);

        vm.openCalendar = openCalendar;
        vm.applySiDateToBlDate = applySiDateToBlDate;
        vm.enterNewKeyword = enterNewKeyword;
        vm.applyShipmentCompany = applyShipmentCompany;
        vm.nl2br = MiscService.nl2br;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.siDate = false;
        vm.datePickerOpenStatus.originEtd = false;
        vm.datePickerOpenStatus.destEta = false;
        vm.datePickerOpenStatus.cutoff = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function applySiDateToBlDate() {
            vm.shipment.blDate = vm.shipment.siDate;
        }

        function resolveDates() {
            vm.shipment.siDate = MiscService.dateFix(vm.shipment.siDate);
            if (vm.shipment.originEtd !== null) {
                vm.shipment.originEtd = MiscService.dateFix(vm.shipment.originEtd);
            }
            if (vm.shipment.destEta !== null) {
                vm.shipment.destEta = MiscService.dateFix(vm.shipment.destEta);
            }
            if (vm.shipment.cutoff !== null) {
                vm.shipment.cutoff = MiscService.dateFix(vm.shipment.cutoff);
            }
            if (vm.shipment.freightPaymentDate !== null) {
                vm.shipment.freightPaymentDate = MiscService.dateFix(vm.shipment.freightPaymentDate);
            }
            if (vm.shipment.lcDate !== null) {
                vm.shipment.lcDate = MiscService.dateFix(vm.shipment.lcDate);
            }
            if (vm.shipment.boeDate !== null) {
                vm.shipment.boeDate = MiscService.dateFix(vm.shipment.boeDate);
            }
            if (vm.shipment.lcExpiry !== null) {
                vm.shipment.lcExpiry = MiscService.dateFix(vm.shipment.lcExpiry);
            }
            if (vm.shipment.lcLatestShipment !== null) {
                vm.shipment.lcLatestShipment = MiscService.dateFix(vm.shipment.lcLatestShipment);
            }
            if (vm.shipment.blDate !== null) {
                vm.shipment.blDate = MiscService.dateFix(vm.shipment.blDate);
            }
        }

        function enterNewKeyword(type) {
            $uibModal.open({
                templateUrl: 'app/entities/keyword/keyword-dialog.html',
                controller: 'KeywordDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return {
                            createdOn: new Date(),
                            createdBy: vm.account.login,
                            modifiedOn: new Date(),
                            modifiedBy: vm.account.login,
                            type: type,
                            value: null,
                            desc: null,
                            id: null
                        };
                    }
                }
            }).result.then(function(retVal) {
                switch(type) {
                    case 'Shipment Company':
                        vm.shipmentCompanyList.push(retVal);
                        vm.shipment.shipmentCompany = retVal.keyword;
                        vm.shipmentCompany = retVal;
                        break;
                }
            });
        }

        function applyShipmentCompany() {
            vm.shipment.shipmentCompany = vm.shipmentCompany.keyword;
        }

        Principal.identity().then(function(account) {
            vm.account = account;
            vm.shipment.modifiedBy = account.login;
        }, function(error) {
            ToastrService.error("Failed to get user", "Error");
            console.log(error.status, error.statusText);
        });

        KeywordCustomService.returnMinifiedKeywordsByType("Shipment Company").then(function(data) {
            vm.shipmentCompanyList = data.data;
            if(vm.shipmentCompanyList.length > 0) {
                for(var i = 0; i < vm.shipmentCompanyList.length; i++) {
                    if(vm.shipmentCompanyList[i].keyword === vm.shipment.shipmentCompany) {
                        vm.shipmentCompany = vm.shipmentCompanyList[i];
                    }
                }
            }
        }, function(error) {
            if(error.status !== "404") {
                ToastrService.error("Failed to get Shipment Companies","Error!");
            }
            console.log(JSON.stringify(error));
        });
        //==================================================================================================//
        //===================================== COMMENTS STUFF =============================================//
        //==================================================================================================//
        vm.addComment = addComment;
        vm.editComment = editComment;

        function resolveComments() {
            vm.comments.length = 0;
            CommentCustomService.returnCommentsByShipment(vm.shipment.id).then(function (data) {
                vm.comments = data.data;
            }, function (error) {
                if (error.status !== "404") {
                    ToastrService.error("Failed to fetch existing comments", "Error!");
                }
                console.log( error.message );
            });
        }

        function addComment() {
            if (vm.comment.length > 0) {
                var comment = [];
                comment.push(createComment(vm.comment));
                CommentCustomService.assignParentToComment(comment, vm.shipment.id, "shipment").then(function () {
                    ToastrService.success("Added Comment to Shipment", "Success!");
                    resolveComments();
                }, function () {
                    ToastrService.error("Failed to Save Comment", "Error");
                });
                vm.comment = "";
            } else {
                console.log('Cannot add comment. vm.comment.length is not (> 0)');
            }
        }

        function createComment(comment) {
            return {
                "id": null,
                "createdOn": new Date(),
                "createdBy": vm.account.login,
                "modifiedOn": new Date(),
                "modifiedBy": vm.account.login,
                "comment": comment,
                "active": true
            };
        }

        function editComment(index) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function () {
                        return vm.comments[index];
                    },
                    shipmentEntity: function () {
                        return Shipment.get({id: vm.shipment.id}).$promise;
                    },
                    contractEntity: function () {
                        return null;
                    },
                    lotEntity: function () {
                        return null;
                    },
                    invoiceEntity: function () {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    }
                }
            }).result.then(function (retVal) {
                ToastrService.success("Successfully Updated Comment", "Success!");
                vm.comments[index] = retVal;
            });
        }

        //==================================================================================================//
        //==================================== ATTACHMENTS STUFF ===========================================//
        //==================================================================================================//
        vm.downloadAttachment = downloadAttachment;

        function resolveAttachments() {
            AttachmentCustomService.returnAttachmentsByShipment(vm.shipment.id).then(function (data) {
                vm.attachments = data.data;
            }, function (error) {
                if (error.status !== "404") {
                    ToastrService.error("Failed to fetch existing attachments: " + error.statusText, "Error!");
                }
                console.log( error.statusText );
            });
        }

        //File Upload
        $scope.files = [];
        $scope.uploadFile = function (file) {
            if( file && file.length ) {
                angular.forEach( file, function( file ) {
                    $scope.files.push( file );
                    AttachmentCustomService.uploadAttachment( file, "shipment", vm.shipment.id, file.name ).then( function( data ) {
                        vm.attachments.push( data.data );
                        ToastrService.success( "Successfully uploaded attachment", "Success!" );
                    }, function( error ) {
                        if( error.status !== 404 ) {
                            ToastrService.error( "Something went wrong with the attachment: " + error.statusText, "Error" );
                        }
                        console.log( error.statusText );
                    });
                    var index = $scope.files.indexOf( file );
                    $scope.files.splice( index, 1 );
                });
            }
        };

        function downloadAttachment(attachment) {
            AttachmentCustomService.downloadAttachment( attachment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/octet-stream'});
                saveAs(file, attachment.fileName );
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Something went wrong: " + error.statusText, "Error");
                    console.log( error.statusText );
                }
            });
        }

        //==================================================================================================//
        //================================= SHIPMENT DOCUMENT STUFF ========================================//
        //==================================================================================================//
        function resolveShipmentDocument(id) {
            ShipmentDocumentCustomService.getShipmentDocumentByShipmentId(id).then(function(data) {
                vm.shipment.shipmentDocument = data.data;
                resolveRequiredDocument();
            }, function(error) {
                if(error.status !== "404") {
                    ToastrService.error("Failed to fetch Shipment Document","Error");
                }
            });
        }

        function resolveRequiredDocument() {
            vm.requiredDocuments = {
                purchaseInvoice: {},
                saleInvoice: {},
                icInvoice: {},
                bl: {},
                pl: {},
                wc: {},
                phyto: {},
                wr: {},
                co: {},
                ic: {},
                sc: {},
                fumigation: {}
            }
            if(vm.shipment.shipmentDocument.purchaseInvoice) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "PURCHASEINVOICE");
            }
            if(vm.shipment.shipmentDocument.saleInvoice) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "SALEINVOICE");
            }
            if(vm.shipment.shipmentDocument.icInvoice) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "ICINVOICE");
            }
            if(vm.shipment.shipmentDocument.bl) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "BL");
            }
            if(vm.shipment.shipmentDocument.pl) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "PL");
            }
            if(vm.shipment.shipmentDocument.wc) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "WC");
            }
            if(vm.shipment.shipmentDocument.phyto) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "PHYTO");
            }
            if(vm.shipment.shipmentDocument.wr) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "WR");
            }
            if(vm.shipment.shipmentDocument.co) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "CO");
            }
            if(vm.shipment.shipmentDocument.ic) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "IC");
            }
            if(vm.shipment.shipmentDocument.sc) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "SC");
            }
            if(vm.shipment.shipmentDocument.fumigation) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, "FUMIGATION");
            }
        }

        vm.shipmentDocumentOptions = [true, false];
        vm.toUpload = {
            purchaseInvoice: [],
            saleInvoice: [],
            icInvoice: [],
            bl: [],
            pl: [],
            wc: [],
            co: [],
            phyto: [],
            wr: [],
            ic: [],
            sc: [],
            fumigation: []
        }
        vm.rdComments = {
            purchaseInvoice: '',
            saleInvoice: '',
            icInvoice: '',
            bl: '',
            pl: '',
            wc: '',
            co: '',
            phyto: '',
            wr: '',
            ic: '',
            sc: '',
            fumigation: ''
        }

        vm.convertBoolean = convertBoolean;
        vm.updateShipmentDocument = updateShipmentDocument;
        vm.uploadFilesPurchaseInvoice = uploadFilesPurchaseInvoice;
        vm.uploadFilesSaleInvoice = uploadFilesSaleInvoice;
        vm.uploadFilesIcInvoice = uploadFilesIcInvoice;
        vm.uploadFilesBl = uploadFilesBl;
        vm.uploadFilesPl = uploadFilesPl;
        vm.uploadFilesWc = uploadFilesWc;
        vm.uploadFilesCo = uploadFilesCo;
        vm.uploadFilesPhyto = uploadFilesPhyto;
        vm.uploadFilesWr = uploadFilesWr;
        vm.uploadFilesIc = uploadFilesIc;
        vm.uploadFilesSc = uploadFilesSc;
        vm.uploadFilesFumigation = uploadFilesFumigation;
        vm.deleteTempRequiredDocument = deleteTempRequiredDocument;
        vm.deleteRequiredDocument = deleteRequiredDocument;
        vm.approveRequiredDocumentAttachment = approveRequiredDocumentAttachment;

        function convertBoolean(value) {
            return value === true ? 'Yes' : 'No';
        }

        function updateShipmentDocument(value, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.shipment.shipmentDocument.purchaseInvoice = value;
                    break;
                case 'SALEINVOICE':
                    vm.shipment.shipmentDocument.saleInvoice = value;
                    break;
                case 'ICINVOICE':
                    vm.shipment.shipmentDocument.icInvoice = value;
                    break;
                case 'BL':
                    vm.shipment.shipmentDocument.bl = value;
                    break;
                case 'PL':
                    vm.shipment.shipmentDocument.pl = value;
                    break;
                case 'WC':
                    vm.shipment.shipmentDocument.wc = value;
                    break;
                case 'CO':
                    vm.shipment.shipmentDocument.co = value;
                    break;
                case 'PHYTO':
                    vm.shipment.shipmentDocument.phyto = value;
                    break;
                case 'WR':
                    vm.shipment.shipmentDocument.wr = value;
                    break;
                case 'IC':
                    vm.shipment.shipmentDocument.ic = value;
                    break;
                case 'SC':
                    vm.shipment.shipmentDocument.sc = value;
                    break;
                case 'FUMIGATION':
                    vm.shipment.shipmentDocument.fumigation = value;
                    break;
            }
            ShipmentDocument.update(vm.shipment.shipmentDocument, function(result) {
                vm.shipment.shipmentDocument = result;
            }, function(error) {
                ToastrService.error("Failed to update Shipment Document", "Error");
            });
            if(value) {
                fetchRequiredDocument(vm.shipment.shipmentDocument.id, type);
            }
        }

        function fetchRequiredDocument(sdId, type) {
            RequiredDocumentCustomService.getRequiredDocumentByShipmentDocumentIdAndType(sdId, type).then(function(data) {
                applyRequiredDocument(data.data, type);
            }, function(error) {
                ToastrService.error("Failed to fetch Required Document for type: " + type, "Error!");
            });
        }

        function applyRequiredDocument(value, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice = value;
                    vm.requiredDocuments.purchaseInvoice.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.purchaseInvoice.id, true).then(function(data) {
                        vm.requiredDocuments.purchaseInvoice.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Purchase Invoice Final Attachment", "Error");
                    });
                    vm.requiredDocuments.purchaseInvoice.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.purchaseInvoice.id, false).then(function(data) {
                        vm.requiredDocuments.purchaseInvoice.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Purchase Invoice Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice = value;
                    vm.requiredDocuments.saleInvoice.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.saleInvoice.id, true).then(function(data) {
                        vm.requiredDocuments.saleInvoice.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Sale Invoice Final Attachment", "Error");
                    });
                    vm.requiredDocuments.saleInvoice.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.saleInvoice.id, false).then(function(data) {
                        vm.requiredDocuments.saleInvoice.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Sale Invoice Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice = value;
                    vm.requiredDocuments.icInvoice.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.icInvoice.id, true).then(function(data) {
                        vm.requiredDocuments.icInvoice.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Invoice Final Attachment", "Error");
                    });
                    vm.requiredDocuments.icInvoice.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.icInvoice.id, false).then(function(data) {
                        vm.requiredDocuments.icInvoice.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Invoice Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'BL':
                    vm.requiredDocuments.bl = value;
                    vm.requiredDocuments.bl.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.bl.id, true).then(function(data) {
                        vm.requiredDocuments.bl.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get BL Final Attachment", "Error");
                    });
                    vm.requiredDocuments.bl.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.bl.id, false).then(function(data) {
                        vm.requiredDocuments.bl.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get BL Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'PL':
                    vm.requiredDocuments.pl = value;
                    vm.requiredDocuments.pl.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.pl.id, true).then(function(data) {
                        vm.requiredDocuments.pl.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get PL Final Attachment", "Error");
                    });
                    vm.requiredDocuments.pl.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.pl.id, false).then(function(data) {
                        vm.requiredDocuments.pl.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get PL Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'WC':
                    vm.requiredDocuments.wc = value;
                    vm.requiredDocuments.wc.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wc.id, true).then(function(data) {
                        vm.requiredDocuments.wc.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WC Final Attachment", "Error");
                    });
                    vm.requiredDocuments.wc.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wc.id, false).then(function(data) {
                        vm.requiredDocuments.wc.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WC Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'CO':
                    vm.requiredDocuments.co = value;
                    vm.requiredDocuments.co.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.co.id, true).then(function(data) {
                        vm.requiredDocuments.co.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get CO Final Attachment", "Error");
                    });
                    vm.requiredDocuments.co.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.co.id, false).then(function(data) {
                        vm.requiredDocuments.co.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get CO Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto = value;
                    vm.requiredDocuments.phyto.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.phyto.id, true).then(function(data) {
                        vm.requiredDocuments.phyto.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Phyto Final Attachment", "Error");
                    });
                    vm.requiredDocuments.phyto.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.phyto.id, false).then(function(data) {
                        vm.requiredDocuments.phyto.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Phyto Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'WR':
                    vm.requiredDocuments.wr = value;
                    vm.requiredDocuments.wr.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wr.id, true).then(function(data) {
                        vm.requiredDocuments.wr.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WR Final Attachment", "Error");
                    });
                    vm.requiredDocuments.wr.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.wr.id, false).then(function(data) {
                        vm.requiredDocuments.wr.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WR Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'IC':
                    vm.requiredDocuments.ic = value;
                    vm.requiredDocuments.ic.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.ic.id, true).then(function(data) {
                        vm.requiredDocuments.ic.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Final Attachment", "Error");
                    });
                    vm.requiredDocuments.ic.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.ic.id, false).then(function(data) {
                        vm.requiredDocuments.ic.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'SC':
                    vm.requiredDocuments.sc = value;
                    vm.requiredDocuments.sc.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.sc.id, true).then(function(data) {
                        vm.requiredDocuments.sc.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get SC Final Attachment", "Error");
                    });
                    vm.requiredDocuments.sc.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.sc.id, false).then(function(data) {
                        vm.requiredDocuments.sc.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get SC Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation = value;
                    vm.requiredDocuments.fumigation.approvedAttachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.fumigation.id, true).then(function(data) {
                        vm.requiredDocuments.fumigation.approvedAttachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Fumigation Final Attachment", "Error");
                    });
                    vm.requiredDocuments.fumigation.attachments = [];
                    AttachmentCustomService.returnAttachmentsByRequiredDocumentAndStatus(vm.requiredDocuments.fumigation.id, false).then(function(data) {
                        vm.requiredDocuments.fumigation.attachments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Fumigation Attachments", "Error");
                    });
                    resolveCommentsRequiredDocument(type);
                    break;
            }
        }

        function uploadFilesPurchaseInvoice(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    vm.toUpload.purchaseInvoice.push(file);
                    if(vm.requiredDocuments.purchaseInvoice.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.purchaseInvoice.id,'PURCHASEINVOICE');
                        spliceFileFromToUpload(file, 'PURCHASEINVOICE');
                    }
                })
            }
        }

        function uploadFilesSaleInvoice(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.saleInvoice.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.saleInvoice.id,'SALEINVOICE');
                        spliceFileFromToUpload(file, 'SALEINVOICE');
                    }
                })
            }
        }

        function uploadFilesIcInvoice(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.icInvoice.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.icInvoice.id,'ICINVOICE');
                        spliceFileFromToUpload(file, 'ICINVOICE');
                    }
                })
            }
        }

        function uploadFilesBl(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.bl.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.bl.id,'BL');
                        spliceFileFromToUpload(file, 'BL');
                    }
                })
            }
        }

        function uploadFilesPl(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.pl.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.pl.id,'PL');
                        spliceFileFromToUpload(file, 'PL');
                    }
                })
            }
        }

        function uploadFilesWc(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.wc.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.wc.id,'WC');
                        spliceFileFromToUpload(file, 'WC');
                    }
                })
            }
        }

        function uploadFilesCo(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.co.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.co.id,'CO');
                        spliceFileFromToUpload(file, 'CO');
                    }
                })
            }
        }

        function uploadFilesPhyto(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.phyto.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.phyto.id,'PHYTO');
                        spliceFileFromToUpload(file, 'PHYTO');
                    }
                })
            }
        }

        function uploadFilesWr(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.wr.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.wr.id,'WR');
                        spliceFileFromToUpload(file, 'WR');
                    }
                })
            }
        }

        function uploadFilesIc(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.ic.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.ic.id,'IC');
                        spliceFileFromToUpload(file, 'IC');
                    }
                })
            }
        }

        function uploadFilesSc(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.sc.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.sc.id,'SC');
                        spliceFileFromToUpload(file, 'SC');
                    }
                })
            }
        }

        function uploadFilesFumigation(file) {
            if(file && file.length) {
                angular.forEach(file, function(file) {
                    if(vm.requiredDocuments.fumigation.id !== null) {
                        uploadAttachmentRequiredDocument(file,vm.requiredDocuments.fumigation.id,'FUMIGATION');
                        spliceFileFromToUpload(file, 'FUMIGATION');
                    }
                })
            }
        }

        function pushFileToRequiredDocument(file, type) {
            switch(type){
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice.attachments.push(file);
                    vm.requiredDocuments.purchaseInvoice.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.purchaseInvoice.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice.attachments.push(file);
                    vm.requiredDocuments.saleInvoice.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.saleInvoice.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice.attachments.push(file);
                    vm.requiredDocuments.icInvoice.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.icInvoice.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'BL':
                    vm.requiredDocuments.bl.attachments.push(file);
                    vm.requiredDocuments.bl.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.bl.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'PL':
                    vm.requiredDocuments.pl.attachments.push(file);
                    vm.requiredDocuments.pl.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.pl.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'WC':
                    vm.requiredDocuments.wc.attachments.push(file);
                    vm.requiredDocuments.wc.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.wc.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'CO':
                    vm.requiredDocuments.co.attachments.push(file);
                    vm.requiredDocuments.co.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.co.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto.attachments.push(file);
                    vm.requiredDocuments.phyto.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.phyto.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'WR':
                    vm.requiredDocuments.wr.attachments.push(file);
                    vm.requiredDocuments.wr.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.wr.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'IC':
                    vm.requiredDocuments.ic.attachments.push(file);
                    vm.requiredDocuments.ic.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.ic.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'SC':
                    vm.requiredDocuments.sc.attachments.push(file);
                    vm.requiredDocuments.sc.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.sc.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation.attachments.push(file);
                    vm.requiredDocuments.fumigation.received = new Date();
                    RequiredDocumentCustomService.updateRequiredDocumentReceivedDate(vm.requiredDocuments.fumigation.id, DateUtils.convertLocalDateToServer(new Date()));
                    break;
            }
        }

        function uploadAttachmentRequiredDocument(file, id, type) {
            AttachmentCustomService.uploadAttachment(file, "required-document", id, file.name).then(function(data) {
                pushFileToRequiredDocument(data.data, type);
            }, function(error) {
                ToastrService.error("Failed to Upload " + file.name, "Error");
            });
        }

        function spliceFileFromToUpload(file, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    var index = vm.toUpload.purchaseInvoice.indexOf(file);
                    vm.toUpload.purchaseInvoice.splice(index,1);
                    break;
                case 'SALEINVOICE':
                    var index = vm.toUpload.saleInvoice.indexOf(file);
                    vm.toUpload.saleInvoice.splice(index,1);
                    break;
                case 'ICINVOICE':
                    var index = vm.toUpload.icInvoice.indexOf(file);
                    vm.toUpload.icInvoice.splice(index,1);
                    break;
                case 'BL':
                    var index = vm.toUpload.bl.indexOf(file);
                    vm.toUpload.bl.splice(index,1);
                    break;
                case 'PL':
                    var index = vm.toUpload.pl.indexOf(file);
                    vm.toUpload.pl.splice(index,1);
                    break;
                case 'WC':
                    var index = vm.toUpload.wc.indexOf(file);
                    vm.toUpload.wc.splice(index,1);
                    break;
                case 'CO':
                    var index = vm.toUpload.co.indexOf(file);
                    vm.toUpload.co.splice(index,1);
                    break;
                case 'PHYTO':
                    var index = vm.toUpload.phyto.indexOf(file);
                    vm.toUpload.phyto.splice(index,1);
                    break;
                case 'WR':
                    var index = vm.toUpload.wr.indexOf(file);
                    vm.toUpload.wr.splice(index,1);
                    break;
                case 'IC':
                    var index = vm.toUpload.ic.indexOf(file);
                    vm.toUpload.ic.splice(index,1);
                    break;
                case 'SC':
                    var index = vm.toUpload.sc.indexOf(file);
                    vm.toUpload.sc.splice(index,1);
                    break;
                case 'FUMIGATION':
                    var index = vm.toUpload.fumigation.indexOf(file);
                    vm.toUpload.fumigation.splice(index,1);
                    break;
            }
        }

        function deleteTempRequiredDocument(index, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.toUpload.purchaseInvoice.splice(index,1);
                    break;
                case 'SALEINVOICE':
                    vm.toUpload.saleInvoice.splice(index,1);
                    break;
                case 'ICINVOICE':
                    vm.toUpload.icInvoice.splice(index,1);
                    break;
                case 'BL':
                    vm.toUpload.bl.splice(index,1);
                    break;
                case 'PL':
                    vm.toUpload.pl.splice(index,1);
                    break;
                case 'WC':
                    vm.toUpload.wc.splice(index,1);
                    break;
                case 'CO':
                    vm.toUpload.co.splice(index,1);
                    break;
                case 'PHYTO':
                    vm.toUpload.phyto.splice(index,1);
                    break;
                case 'WR':
                    vm.toUpload.wr.splice(index,1);
                    break;
                case 'IC':
                    vm.toUpload.ic.splice(index,1);
                    break;
                case 'SC':
                    vm.toUpload.sc.splice(index,1);
                    break;
                case 'FUMIGATION':
                    vm.toUpload.fumigation.splice(index,1);
                    break;
            }
        }

        function spliceFileFromRequiredDocument(index, type, approved) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    if(approved) {
                        vm.requiredDocuments.purchaseInvoice.approvedAttachments.splice(index, 1);
                        if(vm.requiredDocuments.purchaseInvoice.approvedAttachments.length === 0) {
                            vm.requiredDocuments.purchaseInvoice.approved = null;
                            if(vm.requiredDocuments.purchaseInvoice.attachments.length === 0) {
                                vm.requiredDocuments.purchaseInvoice.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.purchaseInvoice.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.purchaseInvoice.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.purchaseInvoice.attachments.splice(index,1);
                        if(vm.requiredDocuments.purchaseInvoice.attachments.length === 0) {
                            vm.requiredDocuments.purchaseInvoice.received = null;
                            RequiredDocumentCustomService.resetReceivedDates(vm.requiredDocuments.purchaseInvoice.id);
                        }
                    }
                    break;
                case 'SALEINVOICE':
                    if(approved) {
                        vm.requiredDocuments.saleInvoice.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.saleInvoice.approvedAttachments.length === 0) {
                            vm.requiredDocuments.saleInvoice.approved = null;
                            if(vm.requiredDocuments.saleInvoice.attachments.length === 0) {
                                vm.requiredDocuments.saleInvoice.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.saleInvoice.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.saleInvoice.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.saleInvoice.attachments.splice(index,1);
                        if(vm.requiredDocuments.saleInvoice.attachments.length === 0) {
                            vm.requiredDocuments.saleInvoice.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.saleInvoice.id);
                        }
                    }
                    break;
                case 'ICINVOICE':
                    if(approved) {
                        vm.requiredDocuments.icInvoice.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.icInvoice.approvedAttachments.length === 0) {
                            vm.requiredDocuments.icInvoice.approved = null;
                            if(vm.requiredDocuments.icInvoice.attachments.length === 0) {
                                vm.requiredDocuments.icInvoice.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.icInvoice.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.icInvoice.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.icInvoice.attachments.splice(index,1);
                        if(vm.requiredDocuments.icInvoice.attachments.length === 0) {
                            vm.requiredDocuments.icInvoice.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.icInvoice.id);
                        }
                    }
                    break;
                case 'BL':
                    if(approved) {
                        vm.requiredDocuments.bl.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.bl.approvedAttachments.length === 0) {
                            vm.requiredDocuments.bl.approved = null;
                            if(vm.requiredDocuments.bl.attachments.length === 0) {
                                vm.requiredDocuments.bl.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.bl.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.bl.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.bl.attachments.splice(index,1);
                        if(vm.requiredDocuments.bl.attachments.length === 0) {
                            vm.requiredDocuments.bl.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.bl.id);
                        }
                    }
                    break;
                case 'PL':
                    if(approved) {
                        vm.requiredDocuments.pl.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.pl.approvedAttachments.length === 0) {
                            vm.requiredDocuments.pl.approved = null;
                            if(vm.requiredDocuments.pl.attachments.length === 0) {
                                vm.requiredDocuments.pl.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.pl.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.pl.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.pl.attachments.splice(index,1);
                        if(vm.requiredDocuments.pl.attachments.length === 0) {
                            vm.requiredDocuments.pl.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.pl.id);
                        }
                    }
                    break;
                case 'WC':
                    if(approved) {
                        vm.requiredDocuments.wc.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.wc.approvedAttachments.length === 0) {
                            vm.requiredDocuments.wc.approved = null;
                            if(vm.requiredDocuments.wc.attachments.length === 0) {
                                vm.requiredDocuments.wc.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.wc.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.wc.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.wc.attachments.splice(index,1);
                        if(vm.requiredDocuments.wc.attachments.length === 0) {
                            vm.requiredDocuments.wc.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.wc.id);
                        }
                    }
                    break;
                case 'CO':
                    if(approved) {
                        vm.requiredDocuments.co.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.co.approvedAttachments.length === 0) {
                            vm.requiredDocuments.co.approved = null;
                            if(vm.requiredDocuments.co.attachments.length === 0) {
                                vm.requiredDocuments.co.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.co.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.co.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.co.attachments.splice(index,1);
                        if(vm.requiredDocuments.co.attachments.length === 0) {
                            vm.requiredDocuments.co.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.co.id);
                        }
                    }
                    break;
                case 'PHYTO':
                    if(approved) {
                        vm.requiredDocuments.phyto.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.phyto.approvedAttachments.length === 0) {
                            vm.requiredDocuments.phyto.approved = null;
                            if(vm.requiredDocuments.phyto.attachments.length === 0) {
                                vm.requiredDocuments.phyto.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.phyto.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.phyto.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.phyto.attachments.splice(index,1);
                        if(vm.requiredDocuments.phyto.attachments.length === 0) {
                            vm.requiredDocuments.phyto.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.phyto.id);
                        }
                    }
                    break;
                case 'WR':
                    if(approved) {
                        vm.requiredDocuments.wr.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.wr.approvedAttachments.length === 0) {
                            vm.requiredDocuments.wr.approved = null;
                            if(vm.requiredDocuments.wr.attachments.length === 0) {
                                vm.requiredDocuments.wr.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.wr.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.wr.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.wr.attachments.splice(index,1);
                        if(vm.requiredDocuments.wr.attachments.length === 0) {
                            vm.requiredDocuments.wr.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.wr.id);
                        }
                    }
                    break;
                case 'IC':
                    if(approved) {
                        vm.requiredDocuments.ic.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.ic.approvedAttachments.length === 0) {
                            vm.requiredDocuments.ic.approved = null;
                            if(vm.requiredDocuments.ic.attachments.length === 0) {
                                vm.requiredDocuments.ic.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.ic.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.ic.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.ic.attachments.splice(index,1);
                        if(vm.requiredDocuments.ic.attachments.length === 0) {
                            vm.requiredDocuments.ic.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.ic.id);
                        }
                    }
                    break;
                case 'SC':
                    if(approved) {
                        vm.requiredDocuments.sc.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.sc.approvedAttachments.length === 0) {
                            vm.requiredDocuments.sc.approved = null;
                            if(vm.requiredDocuments.sc.attachments.length === 0) {
                                vm.requiredDocuments.sc.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.sc.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.sc.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.sc.attachments.splice(index,1);
                        if(vm.requiredDocuments.sc.attachments.length === 0) {
                            vm.requiredDocuments.sc.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.sc.id);
                        }
                    }
                    break;
                case 'FUMIGATION':
                    if(approved) {
                        vm.requiredDocuments.fumigation.approvedAttachments.splice(index,1);
                        if(vm.requiredDocuments.fumigation.approvedAttachments.length === 0) {
                            vm.requiredDocuments.fumigation.approved = null;
                            if(vm.requiredDocuments.fumigation.attachments.length === 0) {
                                vm.requiredDocuments.fumigation.received = null;
                                RequiredDocumentCustomService.resetReceivedAndApprovedDates(vm.requiredDocuments.fumigation.id);
                            } else {
                                RequiredDocumentCustomService.resetApprovedDate(vm.requiredDocuments.fumigation.id);
                            }
                        }
                    } else {
                        vm.requiredDocuments.fumigation.attachments.splice(index,1);
                        if(vm.requiredDocuments.fumigation.attachments.length === 0) {
                            vm.requiredDocuments.fumigation.received = null;
                            RequiredDocumentCustomService.resetReceivedDate(vm.requiredDocuments.fumigation.id);
                        }
                    }
                    break;
            }
        }

        function deleteRequiredDocument(file, index, type, approved) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-delete-modal.html',
                controller: 'AttachmentDeleteModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return file;
                    }
                }
            }).result.then(function(retVal) {
                if(retVal === true) {
                    spliceFileFromRequiredDocument(index, type, approved);
                } else {
                    ToastrService.error("Cannot delete Attachment", "Error");
                }
            });
        }

        function approveRequiredDocumentAttachment(attachment, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.purchaseInvoice.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.purchaseInvoice.attachments.indexOf(attachment);
                        vm.requiredDocuments.purchaseInvoice.attachments.splice(index, 1);
                        if(vm.requiredDocuments.purchaseInvoice.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.purchaseInvoice.approvedAttachments[0];
                            vm.requiredDocuments.purchaseInvoice.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.purchaseInvoice.approvedAttachments = [];
                        vm.requiredDocuments.purchaseInvoice.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve Purchase Invoice Attachment", "Error");
                    });
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.saleInvoice.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.saleInvoice.attachments.indexOf(attachment);
                        vm.requiredDocuments.saleInvoice.attachments.splice(index,1);
                        if(vm.requiredDocuments.saleInvoice.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.saleInvoice.approvedAttachments[0];
                            vm.requiredDocuments.saleInvoice.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.saleInvoice.approvedAttachments = [];
                        vm.requiredDocuments.saleInvoice.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve Sale invoice Attachment", "Error");
                    });
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.icInvoice.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.icInvoice.attachments.indexOf(attachment);
                        vm.requiredDocuments.icInvoice.attachments.splice(index,1);
                        if(vm.requiredDocuments.icInvoice.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.icInvoice.approvedAttachments[0];
                            vm.requiredDocuments.icInvoice.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.icInvoice.approvedAttachments = [];
                        vm.requiredDocuments.icInvoice.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve IC Invoice Attachment", "Error");
                    });
                    break;
                case 'BL':
                    vm.requiredDocuments.bl.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.bl.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.bl.attachments.indexOf(attachment);
                        vm.requiredDocuments.bl.attachments.splice(index,1);
                        if(vm.requiredDocuments.bl.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.bl.approvedAttachments[0];
                            vm.requiredDocuments.bl.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.bl.approvedAttachments = [];
                        vm.requiredDocuments.bl.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve BL Attachment", "Error");
                    });
                    break;
                case 'PL':
                    vm.requiredDocuments.pl.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.pl.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.pl.attachments.indexOf(attachment);
                        vm.requiredDocuments.pl.attachments.splice(index,1);
                        if(vm.requiredDocuments.pl.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.pl.approvedAttachments[0];
                            vm.requiredDocuments.pl.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.pl.approvedAttachments = [];
                        vm.requiredDocuments.pl.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve PL Attachment", "Error");
                    });
                    break;
                case 'WC':
                    vm.requiredDocuments.wc.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.wc.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.wc.attachments.indexOf(attachment);
                        vm.requiredDocuments.wc.attachments.splice(index,1);
                        if(vm.requiredDocuments.wc.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.wc.approvedAttachments[0];
                            vm.requiredDocuments.wc.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.wc.approvedAttachments = [];
                        vm.requiredDocuments.wc.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve WC Attachment", "Error");
                    });
                    break;
                case 'CO':
                    vm.requiredDocuments.co.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.co.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.co.attachments.indexOf(attachment);
                        vm.requiredDocuments.co.attachments.splice(index,1);
                        if(vm.requiredDocuments.co.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.co.approvedAttachments[0];
                            vm.requiredDocuments.co.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.co.approvedAttachments = [];
                        vm.requiredDocuments.co.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve CO Attachment", "Error");
                    });
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.phyto.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.phyto.attachments.indexOf(attachment);
                        vm.requiredDocuments.phyto.attachments.splice(index,1);
                        if(vm.requiredDocuments.phyto.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.phyto.approvedAttachments[0];
                            vm.requiredDocuments.phyto.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.phyto.approvedAttachments = [];
                        vm.requiredDocuments.phyto.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve Phyto Attachment", "Error");
                    });
                    break;
                case 'WR':
                    vm.requiredDocuments.wr.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.wr.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.wr.attachments.indexOf(attachment);
                        vm.requiredDocuments.wr.attachments.splice(index,1);
                        if(vm.requiredDocuments.wr.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.wr.approvedAttachments[0];
                            vm.requiredDocuments.wr.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.wr.approvedAttachments = [];
                        vm.requiredDocuments.wr.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve WR Attachment", "Error");
                    });
                    break;
                case 'IC':
                    vm.requiredDocuments.ic.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.ic.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.ic.attachments.indexOf(attachment);
                        vm.requiredDocuments.ic.attachments.splice(index,1);
                        if(vm.requiredDocuments.ic.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.ic.approvedAttachments[0];
                            vm.requiredDocuments.ic.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.ic.approvedAttachments = [];
                        vm.requiredDocuments.ic.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve IC Attachment", "Error");
                    });
                    break;
                case 'SC':
                    vm.requiredDocuments.sc.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.sc.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.sc.attachments.indexOf(attachment);
                        vm.requiredDocuments.sc.attachments.splice(index,1);
                        if(vm.requiredDocuments.sc.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.sc.approvedAttachments[0];
                            vm.requiredDocuments.sc.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.sc.approvedAttachments = [];
                        vm.requiredDocuments.sc.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve SC Attachment", "Error");
                    });
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation.approved = new Date();
                    AttachmentCustomService.approveAttachment(vm.requiredDocuments.fumigation.id, DateUtils.convertLocalDateToServer(new Date()), attachment.id).then(function() {
                        var index = vm.requiredDocuments.fumigation.attachments.indexOf(attachment);
                        vm.requiredDocuments.fumigation.attachments.splice(index,1);
                        if(vm.requiredDocuments.fumigation.approvedAttachments.length > 0) {
                            var addToAttachments = vm.requiredDocuments.fumigation.approvedAttachments[0];
                            vm.requiredDocuments.fumigation.attachments.push(addToAttachments);
                        }
                        vm.requiredDocuments.fumigation.approvedAttachments = [];
                        vm.requiredDocuments.fumigation.approvedAttachments.push(attachment);
                    }, function(error) {
                        ToastrService.error("Cannot approve Fumigation Attachment", "Error");
                    });
                    break;
            }
        }

        vm.addCommentRequiredDocument = addCommentRequiredDocument;
        vm.editCommentRequiredDocument = editCommentRequiredDocument;
        vm.deleteCommentRequiredDocument = deleteCommentRequiredDocument;

        function resolveCommentsRequiredDocument(type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.purchaseInvoice.id).then(function(data) {
                        vm.requiredDocuments.purchaseInvoice.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Purchase Invoice Comments", "Error");
                    });
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.saleInvoice.id).then(function(data) {
                        vm.requiredDocuments.saleInvoice.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Sale Invoice Comments", "Error");
                    });
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.icInvoice.id).then(function(data) {
                        vm.requiredDocuments.icInvoice.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Invoice Comments", "Error");
                    });
                    break;
                case 'BL':
                    vm.requiredDocuments.bl.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.bl.id).then(function(data) {
                        vm.requiredDocuments.bl.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get BL Comments", "Error");
                    });
                    break;
                case 'PL':
                    vm.requiredDocuments.pl.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.pl.id).then(function(data) {
                        vm.requiredDocuments.pl.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get PL Comments", "Error");
                    });
                    break;
                case 'WC':
                    vm.requiredDocuments.wc.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.wc.id).then(function(data) {
                        vm.requiredDocuments.wc.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WC Comments", "Error");
                    });
                    break;
                case 'CO':
                    vm.requiredDocuments.co.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.co.id).then(function(data) {
                        vm.requiredDocuments.co.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get CO Comments", "Error");
                    });
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.phyto.id).then(function(data) {
                        vm.requiredDocuments.phyto.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Phyto Comments", "Error");
                    });
                    break;
                case 'WR':
                    vm.requiredDocuments.wr.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.wr.id).then(function(data) {
                        vm.requiredDocuments.wr.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get WR Comments", "Error");
                    });
                    break;
                case 'IC':
                    vm.requiredDocuments.ic.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.ic.id).then(function(data) {
                        vm.requiredDocuments.ic.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get IC Comments", "Error");
                    });
                    break;
                case 'SC':
                    vm.requiredDocuments.sc.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.sc.id).then(function(data) {
                        vm.requiredDocuments.sc.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get SC Comments", "Error");
                    });
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation.comments = [];
                    CommentCustomService.returnCommentsByRequiredDocument(vm.requiredDocuments.fumigation.id).then(function(data) {
                        vm.requiredDocuments.fumigation.comments = data.data;
                    }, function(error) {
                        ToastrService.error("Cannot get Comments", "Error");
                    });
                    break;
            }
        }

        function addCommentRequiredDocument(type) {
            var comment = [];
            switch(type) {
                case 'PURCHASEINVOICE':
                    if(vm.requiredDocuments.purchaseInvoice.id !== null && vm.rdComments.purchaseInvoice.length > 0) {
                        comment.push(createComment(vm.rdComments.purchaseInvoice));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.purchaseInvoice.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to Purchase Invoice Document", "Success!");
                            vm.rdComments.purchaseInvoice = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'SALEINVOICE':
                    if(vm.requiredDocuments.saleInvoice.id !== null && vm.rdComments.saleInvoice.length > 0) {
                        comment.push(createComment(vm.rdComments.saleInvoice));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.saleInvoice.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to Sale Invoice Document", "Success!");
                            vm.rdComments.saleInvoice = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'ICINVOICE':
                    if(vm.requiredDocuments.icInvoice.id !== null && vm.rdComments.icInvoice.length > 0) {
                        comment.push(createComment(vm.rdComments.icInvoice));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.icInvoice.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to IC Invoice Document", "Success!");
                            vm.rdComments.icInvoice = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'BL':
                    if(vm.requiredDocuments.bl.id !== null && vm.rdComments.bl.length > 0) {
                        comment.push(createComment(vm.rdComments.bl));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.bl.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to BL Document", "Success!");
                            vm.rdComments.bl = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'PL':
                    if(vm.requiredDocuments.pl.id !== null && vm.rdComments.pl.length > 0) {
                        comment.push(createComment(vm.rdComments.pl));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.pl.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to PL Document", "Success!");
                            vm.rdComments.pl = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'WC':
                    if(vm.requiredDocuments.wc.id !== null && vm.rdComments.wc.length > 0) {
                        comment.push(createComment(vm.rdComments.wc));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.wc.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to WC Document", "Success!");
                            vm.rdComments.wc = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'CO':
                    if(vm.requiredDocuments.co.id !== null && vm.rdComments.co.length > 0) {
                        comment.push(createComment(vm.rdComments.co));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.co.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to CO Document", "Success!");
                            vm.rdComments.co = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'PHYTO':
                    if(vm.requiredDocuments.phyto.id !== null && vm.rdComments.phyto.length > 0) {
                        comment.push(createComment(vm.rdComments.phyto));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.phyto.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to Phyto Document", "Success!");
                            vm.rdComments.phyto = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'WR':
                    if(vm.requiredDocuments.wr.id !== null && vm.rdComments.wr.length > 0) {
                        comment.push(createComment(vm.rdComments.wr));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.wr.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to WR Document", "Success!");
                            vm.rdComments.wr = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'IC':
                    if(vm.requiredDocuments.ic.id !== null && vm.rdComments.ic.length > 0) {
                        comment.push(createComment(vm.rdComments.ic));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.ic.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to IC Document", "Success!");
                            vm.rdComments.ic = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'SC':
                    if(vm.requiredDocuments.sc.id !== null && vm.rdComments.sc.length > 0) {
                        comment.push(createComment(vm.rdComments.sc));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.sc.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to SC Document", "Success!");
                            vm.rdComments.sc = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
                case 'FUMIGATION':
                    if(vm.requiredDocuments.fumigation.id !== null && vm.rdComments.fumigation.length > 0) {
                        comment.push(createComment(vm.rdComments.fumigation));
                        CommentCustomService.assignParentToComment(comment, vm.requiredDocuments.fumigation.id, 'required-document').then(function() {
                            ToastrService.success("Added Comment to Fumigation Document", "Success!");
                            vm.rdComments.fumigation = "";
                            resolveCommentsRequiredDocument(type);
                        });
                    }
                    break;
            }
        }

        function editCommentRequiredDocument(index, type) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return returnCommentEntity(index, type);
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return RequiredDocument.get({id:returnRequiredDocumentId(type)}).$promise;
                    },
                    controllerEntity: function() {
                        return null;
                    },
                    controllerPaymentEntity: function() {
                        return null;
                    }
                }
            }).result.then(function(retVal) {
                updateCommentEntity(index, type, retVal);
            });
        }

        function deleteCommentRequiredDocument(index, type) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-delete-dialog.html',
                controller: 'CommentDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return returnCommentEntity(index, type);
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return RequiredDocument.get({id:returnRequiredDocumentId(type)}).$promise;
                    },
                    controllerEntity: function() {
                        return null;
                    },
                    controllerPaymentEntity: function() {
                        return null;
                    }
                }
            }).result.then(function(retVal) {
                if(retVal === true) {
                    spliceCommentEntity(index,type);
                }
            });
        }

        function returnCommentEntity(index, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    return vm.requiredDocuments.purchaseInvoice.comments[index];
                case 'SALEINVOICE':
                    return vm.requiredDocuments.saleInvoice.comments[index];
                case 'ICINVOICE':
                    return vm.requiredDocuments.icInvoice.comments[index];
                case 'BL':
                    return vm.requiredDocuments.bl.comments[index];
                case 'PL':
                    return vm.requiredDocuments.pl.comments[index];
                case 'WC':
                    return vm.requiredDocuments.wc.comments[index];
                case 'CO':
                    return vm.requiredDocuments.co.comments[index];
                case 'PHYTO':
                    return vm.requiredDocuments.phyto.comments[index];
                case 'WR':
                    return vm.requiredDocuments.wr.comments[index];
                case 'IC':
                    return vm.requiredDocuments.ic.comments[index];
                case 'SC':
                    return vm.requiredDocuments.sc.comments[index];
                case 'FUMIGATION':
                    return vm.requiredDocuments.fumigation.comments[index];
            }
        }

        function returnRequiredDocumentId(type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    return vm.requiredDocuments.purchaseInvoice.id;
                case 'SALEINVOICE':
                    return vm.requiredDocuments.saleInvoice.id;
                case 'ICINVOICE':
                    return vm.requiredDocuments.icInvoice.id;
                case 'BL':
                    return vm.requiredDocuments.bl.id;
                case 'PL':
                    return vm.requiredDocuments.pl.id;
                case 'WC':
                    return vm.requiredDocuments.wc.id;
                case 'CO':
                    return vm.requiredDocuments.co.id;
                case 'PHYTO':
                    return vm.requiredDocuments.phyto.id;
                case 'WR':
                    return vm.requiredDocuments.wr.id;
                case 'IC':
                    return vm.requiredDocuments.ic.id;
                case 'SC':
                    return vm.requiredDocuments.sc.id;
                case 'FUMIGATION':
                    return vm.requiredDocuments.fumigation.id;
            }
        }

        function updateCommentEntity(index, type, retVal) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice.comments[index] = retVal;
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice.comments[index] = retVal;
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice.comments[index] = retVal;
                    break;
                case 'BL':
                    vm.requiredDocuments.bl.comments[index] = retVal;
                    break;
                case 'PL':
                    vm.requiredDocuments.pl.comments[index] = retVal;
                    break;
                case 'WC':
                    vm.requiredDocuments.wc.comments[index] = retVal;
                    break;
                case 'CO':
                    vm.requiredDocuments.co.comments[index] = retVal;
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto.comments[index] = retVal;
                    break;
                case 'WR':
                    vm.requiredDocuments.wr.comments[index] = retVal;
                    break;
                case 'IC':
                    vm.requiredDocuments.ic.comments[index] = retVal;
                    break;
                case 'SC':
                    vm.requiredDocuments.sc.comments[index] = retVal;
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation.comments[index] = retVal;
                    break;
            }
        }

        function spliceCommentEntity(index, type) {
            switch(type) {
                case 'PURCHASEINVOICE':
                    vm.requiredDocuments.purchaseInvoice.comments.splice(index,1);
                    break;
                case 'SALEINVOICE':
                    vm.requiredDocuments.saleInvoice.comments.splice(index,1);
                    break;
                case 'ICINVOICE':
                    vm.requiredDocuments.icInvoice.comments.splice(index,1);
                    break;
                case 'BL':
                    vm.requiredDocuments.bl.comments.splice(index,1);
                    break;
                case 'PL':
                    vm.requiredDocuments.pl.comments.splice(index,1);
                    break;
                case 'WC':
                    vm.requiredDocuments.wc.comments.splice(index,1);
                    break;
                case 'CO':
                    vm.requiredDocuments.co.comments.splice(index,1);
                    break;
                case 'PHYTO':
                    vm.requiredDocuments.phyto.comments.splice(index,1);
                    break;
                case 'WR':
                    vm.requiredDocuments.wr.comments.splice(index,1);
                    break;
                case 'IC':
                    vm.requiredDocuments.ic.comments.splice(index,1);
                    break;
                case 'SC':
                    vm.requiredDocuments.sc.comments.splice(index,1);
                    break;
                case 'FUMIGATION':
                    vm.requiredDocuments.fumigation.comments.splice(index,1);
                    break;
            }
        }

        //==================================================================================================//
        //===================================== SAVE PROCESS ===============================================//
        //==================================================================================================//
        vm.save = save;
        function save() {
            vm.isSaving = true;
            Shipment.update(vm.shipment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            resolveDates();
            ToastrService.success("Shipment Save Success","Success!");
            var data = {
                heading: 'Detail ' + vm.shipment.siNum,
                route: 'shipment.shipment-detail',
                id: vm.shipment.id,
                param: {}
            };
            $rootScope.$emit('handleEmit',data);
            $state.go('shipment.shipment-detail',{id:vm.shipment.id},{reload:true});
        }

        function onSaveError() {
            ToastrService.error("Something went wrong","Error");
            resolveDates();
            vm.isSaving = false;
        }

    }
})();
